export enum EdgeEnum {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

export type FlowEnum = "vertical" | "horizontal";

interface SortableData {
  index: number;
}

interface DndKitItem {
  id: string | number;
  data: {
    current?: {
      sortable?: SortableData;
    };
  };
}

export function useSignifierEdge(
  isOver: boolean,
  active: DndKitItem | null,
  over: DndKitItem | null,
  flow: FlowEnum,
): EdgeEnum | undefined {
  if (isOver && active && over && active.id !== over.id) {
    const activeSortable = active.data.current?.sortable;
    const overSortable = over.data.current?.sortable;
    if (
      activeSortable &&
      overSortable &&
      typeof activeSortable.index === "number" &&
      typeof overSortable.index === "number"
    ) {
      const activeIndex = activeSortable.index;
      const overIndex = overSortable.index;

      if (flow === "vertical") {
        return activeIndex < overIndex ? EdgeEnum.Bottom : EdgeEnum.Top;
      } else {
        return activeIndex < overIndex ? EdgeEnum.Right : EdgeEnum.Left;
      }
    }
  }

  return undefined;
}
